import styled from "styled-components"
import { useState, Link } from "react"
import MenuItem from "./MenuItem"
import SubMenuCon from "./SubMenuCon"
import SubMenuContent01 from "./Contents/SubMenuContent01"
import SubMenuContent02 from "./Contents/SubMenuContent02"
import SubMenuContent03 from "./Contents/SubMenuContent03"
import SubMenuContent04 from "./Contents/SubMenuContent04"
import SubMenuContent05 from "./Contents/SubMenuContent05"
import SubMenuContent06 from "./Contents/SubMenuContent06"
import Cover01 from "../img/cover_large_01.jpg"
import Cover02 from "../img/cover_large_02.jpg"
import Cover03 from "../img/cover_large_03.jpg"
import Cover04 from "../img/cover_large_04.jpg"
import Cover05 from "../img/cover_large_05.jpg"
import Cover06 from "../img/cover_large_06.jpg"
import Cover07 from "../img/cover_large_07.jpg"
import Cover08 from "../img/cover_large_08.jpg"

const MenulistObject = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  flex-wrap: wrap;
  height: auto;
`
const linklink = styled.a`
  background-color: black;
  color: white;
  width: 200px;
  height: 200px;
`
function MenuList() {
  const [subMenu01, setMenu01] = useState(false)
  const [subMenu02, setMenu02] = useState(false)
  const [subMenu03, setMenu03] = useState(false)
  const [subMenu04, setMenu04] = useState(false)
  const [subMenu05, setMenu05] = useState(false)
  const [subMenu06, setMenu06] = useState(false)

  const tranceMenu01 = () => {
    setMenu01(!subMenu01)
  }

  const tranceMenu02 = () => {
    setMenu02(!subMenu02)
  }
  const tranceMenu03 = () => {
    setMenu03(!subMenu03)
  }
  const tranceMenu04 = () => {
    setMenu04(!subMenu04)
  }
  const tranceMenu05 = () => {
    setMenu05(!subMenu05)
  }
  const tranceMenu06 = () => {
    setMenu06(!subMenu06)
  }
  const tranceLink01 = () => {
    window.open("about:blank").location.href = "https://cocarenewal.web.app"
  }

  const tranceLink02 = () => {
    window.open("about:blank").location.href =
      "https://penthouserenewal.web.app"
  }
  return (
    <>
      <linklink></linklink>
      <MenulistObject>
        <MenuItem
          menuTrance={tranceLink02}
          title="Penthouse"
          sub="Renewal Site - Technical ability"
          mainBg={Cover08}
        ></MenuItem>
        <MenuItem
          menuTrance={tranceLink01}
          title="CocaCola"
          sub="Renewal Site - Technical ability"
          mainBg={Cover07}
        ></MenuItem>
        <MenuItem
          title="Service UI"
          sub="Interaction Prototype"
          mainBg={Cover06}
          menuTrance={tranceMenu06}
        ></MenuItem>
        <MenuItem
          title="KBS Verture AD"
          sub="Link to Mobile"
          mainBg={Cover05}
          menuTrance={tranceMenu05}
        ></MenuItem>
        <MenuItem
          title="Olleh TV Mobile"
          sub="Mobile-APP"
          mainBg={Cover04}
          menuTrance={tranceMenu04}
        ></MenuItem>
        <MenuItem
          title="K-Shopping"
          sub="TV-APP"
          mainBg={Cover03}
          menuTrance={tranceMenu03}
        ></MenuItem>
        <MenuItem
          title="Main AD"
          sub="Be Asked from Client"
          mainBg={Cover02}
          menuTrance={tranceMenu02}
        ></MenuItem>
        <MenuItem
          title="CG"
          sub="Graphic List"
          mainBg={Cover01}
          menuTrance={tranceMenu01}
        ></MenuItem>
      </MenulistObject>
      {subMenu06 && (
        <SubMenuCon
          title="Service UI"
          sub="| Interaction Prototype"
          menuTrance={tranceMenu06}
        >
          <SubMenuContent06 />
        </SubMenuCon>
      )}
      {subMenu05 && (
        <SubMenuCon
          title="KBS Verture AD"
          sub="| Link to Mobile"
          menuTrance={tranceMenu05}
        >
          <SubMenuContent05 />
        </SubMenuCon>
      )}
      {subMenu04 && (
        <SubMenuCon
          title="Olleh TV Mobile"
          sub="| Mobile-APP"
          menuTrance={tranceMenu04}
        >
          <SubMenuContent04 />
        </SubMenuCon>
      )}
      {subMenu03 && (
        <SubMenuCon title="K-Shopping" sub="| TV-APP" menuTrance={tranceMenu03}>
          <SubMenuContent03 />
        </SubMenuCon>
      )}
      {subMenu02 && (
        <SubMenuCon
          title="Main AD"
          sub="Be Asked from Client"
          menuTrance={tranceMenu02}
        >
          <SubMenuContent02 />
        </SubMenuCon>
      )}
      {subMenu01 && (
        <SubMenuCon title="CG" sub="| Graphic List" menuTrance={tranceMenu01}>
          <SubMenuContent01 />
        </SubMenuCon>
      )}
    </>
  )
}

export default MenuList
